import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

export default class completeProfileApi {
  static register = (data, headers) => {
    const config = getApiConfig();
    return axios
      .post(config.completeProfileUrl, data, {headers})
      .then(res => res.data);
  };
}
